import { createFileRoute, redirect } from '@tanstack/react-router';

// The standalone Chain searches table was folded into the Chains page
// (in-progress strip) and each chain's Searches tab. Keep the old URL
// working for bookmarks/emails.
export const Route = createFileRoute('/dashboard/scorecard/chains/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/chains' });
  },
});
